/**
 * Set the app base uri to use when in development mode.
 * Keep it empty if you would like to use the env variables.
 */
export const DEV_APP_BASE_URI: string = 'http://gwp-wcards.local/';

/**
 * Set the api base uri to use when in development mode.
 * Keep it empty if you would like to use the env variables.
 */
export const DEV_API_BASE_URI: string = 'http://gwp-wcards.local/api/';
